/**
 * Search Page Controller
 * Handles AJAX search, filters, sort, and pagination
 */
/* eslint-disable camelcase, radix */
import LoadingManager from '../../../FE/src/assets/javascripts/utils/LoadingManager.js';

export default class SearchPage {
  constructor() {
    this.$searchForm = $('.gg-search-hero__search-form');
    this.$filters = $('[data-search-filters]');
    this.$sortControl = $('[data-sort-control]');
    this.$perPageControl = $('[data-per-page-control]');
    this.$resultsContainer = $('[data-search-results]');
    this.$paginationContainer = $('[data-search-pagination]');
    this.$resultsHeader = $('.gg-search-results__header');
    this.clsFiltersitem = 'gg-search-filters__item';
    this.clsLoading = 'loading opacity-50 pointer-events-none';
    this.dataFilterOption = 'data-filter-option';
    this.currentParams = this.getUrlParams();
    this.postTypeArr = 'post_type[]'
  }

  init() {
    this.bindEvents();
    this.listenToHeroBanner();
    this.initMobileFilters();
  }

  initMobileFilters() {
    const $filterToggle = $('[data-filter-toggle]');
    const $filterClose = $('[data-filter-close]');
    const $filterOverlay = $('[data-filter-overlay]');

    // Open filters
    $filterToggle.on('click', () => {
      this.$filters.addClass('is-open');
      $('body').css('overflow', 'hidden');
    });

    // Close filters
    $filterClose.on('click', () => this.closeMobileFilters());
    $filterOverlay.on('click', () => this.closeMobileFilters());

    // Close on ESC key
    $(document).on('keydown', (e) => {
      if (e.key === 'Escape' && this.$filters.hasClass('is-open')) {
        this.closeMobileFilters();
      }
    });
  }

  closeMobileFilters() {
    this.$filters.removeClass('is-open');
    $('body').css('overflow', '');
  }

  bindEvents() {
    // Filter checkbox change
    this.$filters.on('change', `[${this.dataFilterOption}]`, (_e) => {
      // Get all checked filter values
      const checkedFilters = [];
      this.$filters.find(`[${this.dataFilterOption}]:checked`).each(function () {
        checkedFilters.push($(this).val());
      });

      this.currentParams.post_type = checkedFilters;
      // Reset to page 1
      this.currentParams.page = 1;
      this.performSearch();

      // Update clear button state
      this.updateClearButtonState();

      // Close mobile filters after applying
      if (window.innerWidth < 768) {
        this.closeMobileFilters();
      }
    });

    // Clear filters button
    this.$filters.on('click', '.gg-filter-controls__clear-btn', (e) => {
      e.preventDefault();

      // Uncheck all filters
      this.$filters.find(`[${this.dataFilterOption}]`).prop('checked', false);

      // Reset post_type to empty array (show all)
      this.currentParams.post_type = [];
      this.currentParams.page = 1;
      
      // Reset sort to default
      this.currentParams.sort = 'newest';
      if (this.$sortControl.data('ggSelect')) {
        this.$sortControl.data('ggSelect').reset();
      }
      
      this.performSearch();

      // Update clear button state
      this.updateClearButtonState();

      // Close mobile filters after clearing
      if (window.innerWidth < 768) {
        this.closeMobileFilters();
      }
    });

    // Sort control using gg-select
    $(document).on('searchSortChanged', (_e, value) => {
      this.currentParams.sort = value;
      this.performSearch();
    });

    // Per page control using gg-select
    $(document).on('searchPerPageChanged', (_e, value) => {
      this.currentParams.per_page = parseInt(value);
      // Reset to page 1
      this.currentParams.page = 1;
      this.performSearch();
    });

    // Pagination clicks (delegated)
    $(document).on('click', '.page-numbers:not(.dots)', (e) => {
      e.preventDefault();
      const $link = $(e.currentTarget);

      // Don't handle disabled links
      if ($link.hasClass('disabled')) {
        return;
      }

      const page = $link.data('page');
      if (page && page > 0) {
        this.currentParams.page = page;
        this.performSearch();
      }
    });
  }

  listenToHeroBanner() {
    // Listen to searchFromBanner event from news-hero
    $(document).on('searchFromBanner', (_e, searchQuery) => {
      this.currentParams.search = searchQuery;
      this.currentParams.page = 1;
      this.performSearch();
    });
  }

  performSearch() {
    // Show loading state
    this.$resultsContainer.addClass(this.clsLoading);
    LoadingManager.show();
    // AJAX request
    $.ajax({
      url: window.ajaxurl || '/wp-admin/admin-ajax.php',
      type: 'POST',
      dataType: 'json',
      data: {
        action: 'search_posts',
        search: this.currentParams.search,
        post_type: this.currentParams.post_type,
        sort: this.currentParams.sort,
        page: this.currentParams.page,
        per_page: this.currentParams.per_page,
      },
      success: (response) => {
        if (response.success) {
          // Update results
          this.$resultsContainer.html(response.data.results_html);

          // Update pagination
          this.$paginationContainer.html(response.data.pagination_html);

          // Update filter counts
          this.updateFilterCounts(response.data.filter_counts);

          // Update filter UI (checkboxes and active states)
          this.updateFilterUI();

          // Update results summary
          this.updateResultsSummary(
            response.data.showing_from,
            response.data.showing_to,
            response.data.total_results,
          );

          // Update URL
          this.updateUrl();

          // Scroll to top of results
          this.scrollToResults();
        }
        LoadingManager.hide();
        this.$resultsContainer.removeClass(
          this.clsLoading,
        );
      },
      error: (_xhr, _status, error) => {
        console.error('Search error:', error);
        LoadingManager.hide();
        this.$resultsContainer.removeClass(this.clsLoading);
      },
      complete: () => {
        LoadingManager.hide();
        this.$resultsContainer.removeClass(
          this.clsLoading,
        );
      },
    });
  }

  updateFilterCounts(counts) {
    Object.keys(counts).forEach((key) => {
      const $countSpan = $(`.filter-count[data-count='${key}']`);
      if ($countSpan.length) {
        $countSpan.text(counts[key]);
        if (counts[key] === 0) {
          $countSpan.closest(`.${this.clsFiltersitem}`).addClass('disabled');
        } else {
          $countSpan.closest(`.${this.clsFiltersitem}`).removeClass('disabled');
        }
      }
    });
  }

  updateResultsSummary(actualShowing, _to, total) {
    const searchTerm = this.currentParams.search;

    // Update showing count
    $('[data-showing-from]').text(actualShowing);

    // Update total results
    $('[data-total-results]').text(total);

    // Show/hide 'X of' wrapper based on total
    if (total > 0) {
      $('[data-showing-wrapper]').show();
    } else {
      $('[data-showing-wrapper]').hide();
    }

    // Update search term
    if (searchTerm) {
      $('[data-search-term]').text(searchTerm);
      $('[data-search-term-wrapper]').show();
    } else {
      $('[data-search-term-wrapper]').hide();
    }
  }

  updateUrl() {
    const url = new URL(window.location);
    url.searchParams.set('s', this.currentParams.search);

    Object.keys(this.currentParams).forEach((key) => {
      // Already handled above
      if (key === 'search') {
        return;
      }

      const value = this.currentParams[key];

      // Handle post_type array
      if (key === 'post_type') {
        url.searchParams.delete(this.postTypeArr);
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((type) => {
            url.searchParams.append(this.postTypeArr, type);
          });
        }
        return;
      }

      // Handle other params
      if (value && value !== 'newest' && value !== 20 && value !== 1) {
        url.searchParams.set(key, value);
      } else {
        url.searchParams.delete(key);
      }
    });

    window.history.pushState({}, '', url);
  }

  scrollToResults() {
    const $target = $('.gg-search-content');
    if ($target.length) {
      $('html, body').animate(
        {
          scrollTop: $target.offset().top - 100,
        },
        300,
      );
    }
  }

  getUrlParams() {
    const params = new URLSearchParams(window.location.search);

    // Get post_type array from URL
    const postTypes = params.getAll(this.postTypeArr);

    return {
      search: params.get('s') || '',
      post_type: postTypes.length > 0 ? postTypes : [],
      sort: params.get('sort') || 'newest',
      page: parseInt(params.get('page')) || 1,
      per_page: parseInt(params.get('per_page')) || 20,
    };
  }

  updateClearButtonState() {
    const $clearBtn = this.$filters.find('.gg-filter-controls__clear-btn');
    const hasActiveFilters =
      this.$filters.find('[data-filter-option]:checked').length > 0;
    const hasNonDefaultSort = this.currentParams.sort && this.currentParams.sort !== 'newest';
    const hasAnyFilters = hasActiveFilters || hasNonDefaultSort;

    if (hasAnyFilters) {
      $clearBtn.prop('disabled', false);
    } else {
      $clearBtn.prop('disabled', true);
    }
  }

  updateFilterUI() {
    const activeFilters = Array.isArray(this.currentParams.post_type)
      ? this.currentParams.post_type
      : [];

    // Update all filter items
    this.$filters.find('[data-filter-option]').each(function () {
      const $checkbox = $(this);
      const $item = $checkbox.closest(`.gg-search-filters__item`);
      const value = $checkbox.val();
      const isActive = activeFilters.includes(value);

      // Update checkbox state
      $checkbox.prop('checked', isActive);

      // Update item active class
      if (isActive) {
        $item.addClass('active');
      } else {
        $item.removeClass('active');
      }

      // Update checkbox icon
      const $icon = $item.find('.gg-search-filters__checkbox .icomoon');
      if (isActive && $icon.length === 0) {
        $item
          .find('.gg-search-filters__checkbox')
          .append('<span class="icomoon icon-checkmark"></span>');
      } else if (!isActive && $icon.length > 0) {
        $icon.remove();
      } else {
        // No change needed
      }
    });
  }
}

// Initialize
$(document).ready(() => {
  if ($('.gg-search-content').length) {
    new SearchPage().init();
  }
});
